<div *ngIf="isPageReady" id="statusChangeDialog" class="flex flex-col">
  <div>
    <h5>Change status to:</h5>
  </div>
  <div class="flex flex-col gap-4 mt-3">
    <div *ngFor="let status of statuses" class="field-checkbox">
      <p-radioButton [disabled]="!isAvailable(status)" name="statusname" [value]="status" [(ngModel)]="currentStatus">
      </p-radioButton>
      <label class="ml-2">{{ status.description + ( isAvailable(status) ? '' : ' (not available)') }}</label>
    </div>
  </div>
  <div class="flex">
    <div class="mr-2 mt-3">
      <button #ok pButton [disabled]="isDisabled()" class="p-button-sm" (click)="onOk()" label="Ok" icon="pi pi-check"
        id="statusChangeOkBtn"></button>
    </div>

    <div class="pr-2 mt-3">
      <button pButton (click)="onCancel()" class="p-button-sm" icon="pi pi-times" label="Cancel"></button>
    </div>
  </div>
</div>